import { api } from "../../../../api/Middleware";
import {
  PIPELINES_URL,
  PIPELINES_REORDER_URL,
  PIPELINES_FUNNEL_URL,
  PIPELINES_SUMMARY_URL,
  PIPELINES_SHARE_URL,
  COLUMNS_URL,
  COLUMNS_BOARD_URL,
  COLUMNS_REORDER_URL,
  COLUMNS_STATS_URL,
  COLUMNS_MOVE_ALL_URL,
} from "../../../../api/Urls";

// ========== Pipelines ==========

export const getPipelines = async () => {
  const response = await api.get(PIPELINES_URL);
  return response.data;
};

export const createPipeline = async (data) => {
  const response = await api.post(PIPELINES_URL, data);
  return response.data;
};

export const updatePipeline = async (id, data) => {
  const response = await api.patch(`${PIPELINES_URL}${id}/`, data);
  return response.data;
};

export const deletePipeline = async (id) => {
  const response = await api.delete(`${PIPELINES_URL}${id}/`);
  return response.data;
};

export const reorderPipelines = async (items) => {
  const response = await api.post(PIPELINES_REORDER_URL, items);
  return response.data;
};

export const getPipelineFunnel = async (id) => {
  const response = await api.get(PIPELINES_FUNNEL_URL(id));
  return response.data;
};

export const getPipelineSummary = async (id, period = 30) => {
  const response = await api.get(PIPELINES_SUMMARY_URL(id), { params: { period } });
  return response.data;
};

// ========== Sharing ==========

export const sharePipeline = async (id, data) => {
  const response = await api.post(PIPELINES_SHARE_URL(id), data);
  return response.data;
};

// ========== Board (unified) ==========

export const getBoardData = async (pipelineId, contactsLimit = 10, signal, filters = {}) => {
  // Monta URLSearchParams manualmente pra suportar arrays como repeated keys
  // (?tags=1&tags=2 em vez do default axios `?tags[]=1&tags[]=2`).
  // BE Django REST espera query_params.getlist('tags') no formato sem [].
  const params = new URLSearchParams();
  params.append("pipeline", pipelineId);
  params.append("contacts_limit", contactsLimit);
  Object.entries(filters || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    if (Array.isArray(value)) {
      value.forEach((v) => params.append(key, v));
    } else {
      params.append(key, value);
    }
  });
  const response = await api.get(`${COLUMNS_BOARD_URL}?${params.toString()}`, { signal });
  return response.data;
};

// ========== Columns ==========

export const getColumns = async (pipelineId) => {
  const params = pipelineId ? { pipeline: pipelineId } : {};
  const response = await api.get(COLUMNS_URL, { params });
  return response.data;
};

export const createColumn = async (data) => {
  const response = await api.post(COLUMNS_URL, data);
  return response.data;
};

export const updateColumn = async (id, data) => {
  const response = await api.patch(`${COLUMNS_URL}${id}/`, data);
  return response.data;
};

export const deleteColumn = async (id) => {
  const response = await api.delete(`${COLUMNS_URL}${id}/`);
  return response.data;
};

export const reorderColumns = async (items) => {
  const response = await api.post(COLUMNS_REORDER_URL, items);
  return response.data;
};

export const getColumnStats = async (id) => {
  const response = await api.get(COLUMNS_STATS_URL(id));
  return response.data;
};

export const moveAllContacts = async (columnId, targetColumnId) => {
  const response = await api.post(COLUMNS_MOVE_ALL_URL(columnId), {
    target_column_id: targetColumnId,
  });
  return response.data;
};
